/**
 *
 * Asynchronously loads the component for CumulativeReportGenerator
 *
 */

import { lazyLoad } from 'controller/utils/loadable';

export const CumulativeReportGenerator = lazyLoad(
  () => import('./index'),
  module => module.CumulativeReportGenerator,
);
